import { useContext, useState } from 'react';

import styles from './notification.module.scss';
import checkIcon from '../../../assets/icons/checkicon_white.svg';
import wifiErrorIcon from '../../../assets/icons/wifi_error.svg';
import { AppContext } from '../../../router/approuter';

const Notification = ({
    data
}) => {

    const appContext = useContext(AppContext)

    return(
        <div className={ appContext.isDesktopOrLaptop ? styles.notification : styles.notification_mobile } 
            style={ { display: data.isDisplay ? 'block' : 'none' } }>
            <div className={ data.notificationStyle }>
                <img src={ data.isErrorConection ? wifiErrorIcon : (data.icon ? data.icon : checkIcon) } alt="" />
                <p>{ data.message ? data.message : '¡Conexión débil o inexistente! Verifica tu conexión y vuelve a intentarlo.' }</p>
            </div>
        </div>
    )
}
export default Notification